var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_772_989)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5253 11.2839C17.7161 11.3667 17.7304 11.3999 17.7435 11.593C17.7435 13.1329 17.7485 14.6726 17.7435 16.2125C17.7262 18.0585 16.1331 19.7808 14.1566 19.7994C11.0788 19.8089 8.00119 19.8092 4.92337 19.7994C3.06734 19.7817 1.35616 18.1921 1.33746 16.2133C1.32762 13.1353 1.32762 10.0572 1.33746 6.97921C1.35502 5.11693 2.9433 3.39953 4.94618 3.39313H12.1981C12.4394 3.4097 12.4857 3.49272 12.5193 3.65448C12.5588 3.84512 12.402 4.03543 12.1981 4.04938C9.77454 4.04938 7.35101 4.04183 4.92748 4.04954C3.40891 4.06382 2.00897 5.36483 1.99355 6.98347C1.98387 10.0587 1.98387 13.1338 1.99355 16.2092C2.00815 17.7356 3.309 19.1277 4.92748 19.1431C8.0025 19.153 11.0775 19.1526 14.1525 19.1431C15.6801 19.1289 17.0822 17.7855 17.0873 16.1895V11.593C17.1017 11.381 17.2971 11.2199 17.5253 11.2839ZM18.3632 1.24785C19.457 1.2695 20.332 2.64336 19.6071 3.685L13.8131 11.9039C13.7732 11.9541 13.7606 11.9656 13.7066 12.0002L11.0683 13.4954C10.8375 13.6091 10.5412 13.4149 10.5863 13.1384L11.2324 10.239C11.2477 10.1835 11.2537 10.1697 11.2846 10.1212L17.0784 1.90246C17.3703 1.49378 17.85 1.24391 18.3632 1.24785ZM18.3325 1.90393C18.05 1.90886 17.7787 2.05126 17.6136 2.28226L11.8586 10.4457L11.3874 12.5601L13.3191 11.4655C15.2381 8.74321 17.1741 6.03257 19.0764 3.29863C19.427 2.78118 19.0736 1.9356 18.3762 1.90459C18.3616 1.9041 18.347 1.90393 18.3325 1.90393Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_772_989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6b52bdd8ecb65b80648fb4cf995d863a.svg";
export { ForwardRef as ReactComponent };